import { users_subscription_route } from "@/constants";
import { authedFetch } from "@/lib/api-client";
import type { AuthFetchParams } from "./global";
import { queryOptions, useQuery } from "@tanstack/react-query";
import type { Subscription } from "@/lib/types";
import { useAuth } from "@/providers/auth";
import { useOrg } from "@/providers/organization";

async function getSubscriptions(params: AuthFetchParams) {
  const resp = await authedFetch(users_subscription_route, {
    method: "GET",
    token: params.token,
    orgId: params.orgId,
  });

  if (resp.status > 399) {
    throw new Error("error fetching subscription");
  }

  const access = resp.headers.get("access-token");
  if (access) params.setToken(access);

  return (await resp.json()) as Subscription;
}

export const billingQueryOpts = (params: AuthFetchParams) =>
  queryOptions({
    queryKey: ["billing"],
    queryFn: async () => await getSubscriptions(params),
  });

export function useBilling() {
  const { getToken, setToken } = useAuth();
  const { orgId } = useOrg();
  return useQuery(
    billingQueryOpts({
      orgId: orgId,
      setToken,
      token: getToken() ?? "",
    }),
  );
}
